import { useEffect, useRef, useState } from "react";
import { fetchItems } from "../api";
import { isAuthenticated, startLogin } from "../auth";
import { ShoppingListItem } from "../types";

export function useItemsWithAuth() {
  const [items, setItems] = useState<ShoppingListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | "signin-required" | null>(null);
  const hasRedirectedToLogin = useRef(false);

  const load = async () => {
    setError(null);
    if (!isAuthenticated()) {
      setLoading(false);
      setError("signin-required");
      return;
    }
    setLoading(true);
    try {
      const data = await fetchItems();
      setItems(data);
    } catch (err) {
      const typed = err as Error & { status?: number };
      if (typed.status === 401) {
        setError("signin-required");
      } else {
        setError(typed.message ?? "Unable to load items");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error === "signin-required" && !hasRedirectedToLogin.current) {
      hasRedirectedToLogin.current = true;
      startLogin();
    }
  }, [error]);

  return { items, setItems, loading, error, setError, refresh: load } as const;
}
